app.showAccount = () => {
  const init = () => {};
  return init();
};

app.editAccount = () => {
  const init = () => {};
  return init();
};
